var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardItemBlueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 67.5C80 72.1233 79.5352 76.638 78.6497 81H0V1.15514C4.0508 0.396657 8.22908 0 12.5 0C49.7792 0 80 30.2208 80 67.5Z",
    fill: "#2F89E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 32.5927L50.9001 34.173L41.1001 43.852L39.0001 32.5927ZM25.0001 64.1977L13.1001 62.6174L22.9001 52.9384L25.0001 64.1977ZM16.0001 41.4816L17.6001 29.7285L27.4001 39.4075L16.0001 41.4816Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 45.6296L13.1 46.4198C13 47.1111 13 47.7037 13 48.3951C13 52.9383 14.6 57.284 17.6 60.642L20.6 58.0741C18.3 55.4074 17 51.9506 17 48.3951C17 47.5062 17.1 46.5185 17.3 45.6296ZM32 29.6296C26.6 29.6296 21.8 31.9012 18.3 35.4568L21.1 38.2222C23.9 35.358 27.7 33.5803 32 33.5803C32.9 33.5803 33.9 33.679 34.8 33.8766L35.5 30.0247C34.4 29.7284 33.2 29.6296 32 29.6296ZM46.7 51.1605L50.9 50.3704C51 49.679 51 49.0864 51 48.3951C51 44.0494 49.5 39.8025 46.7 36.4445L43.6 38.9136C45.8 41.5803 47 44.9383 47 48.2963C47 49.284 46.9 50.2716 46.7 51.1605ZM42.9 58.5679C40.1 61.4321 36.3 63.2099 32 63.2099C31.1 63.2099 30.1 63.1111 29.2 62.9136L28.5 66.7654C29.7 66.963 30.9 67.0617 32 67.0617C37.4 67.0617 42.2 64.7901 45.7 61.2346L42.9 58.5679Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 55.3086L46.4001 67.0617L36.6001 57.3827L48.0001 55.3086Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardItemBlueIcon);
export default __webpack_public_path__ + "static/media/DashboardItemBlueIcon.ff738b2d289c9539545dbf670ac66d7e.svg";
export { ForwardRef as ReactComponent };